import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import * as COMMONFUNCTIONS from '../../utils/CommonFunctions'

import Top from '../../components/common/top';
import Header from '../../components/common/header';
import Footer from '../../components/common/footer';

import { Link } from "react-router-dom";

function Error404()
{
    useEffect(() => {
        COMMONFUNCTIONS.moveToTop();
    })
    return (
        <div>
            <Top/>
            <Header/>
            {/* REGISTER */}
            <section>
                <div class="login pg-404">
                    <div class="container">
                        <div class="row">
                            <div class="inn">
                                <div class="lhs">
                                    <div class="tit">
                                        <h2>Page not found <b>404</b></h2>
                                        <h5>We can't seem to find the page you are looking for.</h5>
                                        <Link className="cta-4" to="/index.html">Visit home page now</Link>
                                    </div>
                                    <div class="log-bg">&nbsp;</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END */}
            <Footer/>
        </div>
    )
}

export default Error404